export default __webpack_public_path__ + "4c9bb387ed4dbafe9a6ee0885a777fa2.png";